var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-result',{attrs:{"icon":"error","title":_vm.$t('language000090')}})}
var staticRenderFns = []

export { render, staticRenderFns }